export const SVGcircleHeart = () => (
	<svg width={64} height={64} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-auto">
		<circle cx={32} cy={32} r={32} fill="white" />
		<mask id="mask0_291_10040" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x={10} y={10} width={45} height={45}>
			<path d="M54.6667 10H10V54.6667H54.6667V10Z" fill="white" />
		</mask>
		<g mask="url(#mask0_291_10040)">
			<path
				d="M47.6875 39.0333V43.0347C47.6875 45.6403 45.6403 47.6875 43.0347 47.6875H21.6319C19.0264 47.6875 16.9792 45.6403 16.9792 43.0347V30.4722"
				stroke="#E5144C"
				strokeWidth="2.79"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.9792 24.1444V21.6319C16.9792 19.0264 19.0264 16.9792 21.6319 16.9792H43.0347C45.6403 16.9792 47.6875 19.0264 47.6875 21.6319V32.8917"
				stroke="#E5144C"
				strokeWidth="2.79"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M16.9792 24.4236H47.6875" stroke="#E5144C" strokeWidth="2.79" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M23.4931 14.6528V18.8403" stroke="#E5144C" strokeWidth="2.79" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M41.1736 14.6528V18.8403" stroke="#E5144C" strokeWidth="2.79" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M28.0528 39.7778C29.7278 41.3597 31.6819 42.2903 32.3333 42.2903C33.7292 42.2903 39.7778 38.1028 39.7778 33.6361C39.7778 31.4028 38.0097 29.6347 35.7764 29.6347C34.2875 29.6347 32.9847 30.4722 32.3333 31.6819C31.6819 30.4722 30.3792 29.6347 28.8903 29.6347C26.6569 29.6347 24.8889 31.4028 24.8889 33.6361C24.8889 34.1944 24.9819 34.6597 25.075 35.2181"
				stroke="#E5144C"
				strokeWidth="2.79"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
	</svg>
)

export const SVGcircleCards = () => (
	<svg width={64} height={64} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-auto">
		<circle cx={32} cy={32} r={32} fill="white" />
		<g clipPath="url(#clip0_291_10046)">
			<mask id="mask0_291_10046" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x={10} y={10} width={45} height={45}>
				<path d="M54.6667 10H10V54.6667H54.6667V10Z" fill="white" />
			</mask>
			<g mask="url(#mask0_291_10046)">
				<path
					d="M37.9093 43.701C38.2052 45.7268 36.7898 47.6261 34.764 47.922L21.873 49.8036C19.8472 50.0995 17.9479 48.6841 17.652 46.6583L15.2996 30.5448C15.0037 28.519 16.5819 26.6197 18.6077 26.3238L22.7552 25.718"
					stroke="#E5144C"
					strokeWidth="2.79"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M26.9975 28.3515L28.6381 18.1535C28.9629 16.1323 30.8826 14.7449 32.9047 15.0697L45.7668 17.1392C47.788 17.464 49.1755 19.3837 48.8507 21.4058L48.5259 23.427"
					stroke="#E5144C"
					strokeWidth="2.79"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M47.6978 28.572L46.2638 37.484C45.939 39.5051 44.0193 40.8926 41.9972 40.5678L29.135 38.4983C27.1139 38.1735 25.7264 36.2538 26.0512 34.2317"
					stroke="#E5144C"
					strokeWidth="2.79"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</g>
		<defs>
			<clipPath id="clip0_291_10046">
				<rect width="44.6667" height="44.6667" fill="white" transform="translate(10 10)" />
			</clipPath>
		</defs>
	</svg>
)
export const SVGcircleGift = () => (
	<svg width={64} height={64} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-auto">
		<circle cx={32} cy={32} r={32} fill="white" />
		<g clipPath="url(#clip0_291_10051)">
			<mask id="mask0_291_10051" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x={10} y={10} width={45} height={45}>
				<path d="M54.6667 10H10V54.6667H54.6667V10Z" fill="white" />
			</mask>
			<g mask="url(#mask0_291_10051)">
				<path
					d="M36.2416 31.868H17.9097C17.3513 31.868 16.9791 31.4958 16.9791 30.9375V24.4236C16.9791 23.8653 17.3513 23.493 17.9097 23.493H46.7569C47.3152 23.493 47.6874 23.8653 47.6874 24.4236V30.9375C47.6874 31.4958 47.3152 31.868 46.7569 31.868H41.1735"
					stroke="#E5144C"
					strokeWidth="2.79"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M45.8263 31.868V44.8958C45.8263 47.5014 43.7791 49.5486 41.1736 49.5486H23.493C20.8874 49.5486 18.8402 47.5014 18.8402 44.8958V37.4514"
					stroke="#E5144C"
					strokeWidth="2.79"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M27.6805 23.4931C25.0749 23.4931 23.0277 21.4458 23.0277 18.8403C23.0277 16.2347 25.0749 14.1875 27.6805 14.1875C30.2861 14.1875 32.3333 16.2347 32.3333 18.8403"
					stroke="#E5144C"
					strokeWidth="2.79"
					strokeLinejoin="round"
				/>
				<path
					d="M32.3333 18.8403C32.3333 16.2347 34.3805 14.1875 36.9861 14.1875C39.5916 14.1875 41.6388 16.2347 41.6388 18.8403C41.6388 21.4458 39.5916 23.4931 36.9861 23.4931"
					stroke="#E5144C"
					strokeWidth="2.79"
					strokeLinejoin="round"
				/>
				<path d="M32.3333 49.5486V18.375" stroke="#E5144C" strokeWidth="2.79" strokeLinejoin="round" />
			</g>
		</g>
		<defs>
			<clipPath id="clip0_291_10051">
				<rect width="44.6667" height="44.6667" fill="white" transform="translate(10 10)" />
			</clipPath>
		</defs>
	</svg>
)
